import React, {useState, useEffect} from 'react';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {ThemeProvider, createTheme, useColorScheme} from '@mui/material/styles';
import LaptopIcon from '@mui/icons-material/Laptop';
import ComputerOutlinedIcon from '@mui/icons-material/ComputerOutlined';
import LightModeIcon from '@mui/icons-material/LightMode';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';


export default function ThemeButtons() {
    const {mode, setMode} = useColorScheme();


    if (!mode) {
        return null;
    }


    return (
        <>
            <ToggleButtonGroup
                color="primary"
                size="small"
                value={mode}
                exclusive
                onChange={(event) =>
                    setMode(event.target.value as 'system' | 'light' | 'dark')
                }
            >
                <ToggleButton color="primary" value="system" aria-label="system">
                    <ComputerOutlinedIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                </ToggleButton>
                <ToggleButton color="primary" value="light" aria-label="light">
                    <LightModeOutlinedIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                </ToggleButton>
                <ToggleButton color="primary" value="dark" aria-label="dark">
                    <DarkModeOutlinedIcon fontSize="small" sx={{pointerEvents: "none"}}/>
                </ToggleButton>
            </ToggleButtonGroup>
        </>
    );
}
